export default __webpack_public_path__ + "assets/8ad846ac7bdcad6dc6e40839069c9739.jpg";